import React, { FC, useEffect, useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

type EInvoiceInviteDialogProps = {
    open: boolean;
    defaultEmail?: string;
    sending: boolean;
    onClose: () => void;
    onSend: (email: string, message: string) => void;
};

/** DD-3726: the e-mail (and optional message) a Crediflow invite is sent with. */
const EInvoiceInviteDialog: FC<EInvoiceInviteDialogProps> = ({ open, defaultEmail, sending, onClose, onSend }) => {
    const { t: translate } = useTranslation(['client-directory', 'common']);
    const [email, setEmail] = useState(defaultEmail || '');
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (open) {
            setEmail(defaultEmail || '');
            setMessage('');
        }
    }, [open]);

    return (
        <DHDialog
            open={open}
            size="sm"
            fullWidth
            onClose={onClose}
            title={translate('client-directory:E_INVOICING_INVITE_TITLE')}
            actions={
                <>
                    <Button onClick={onClose} disabled={sending}>
                        {translate('common:CANCEL')}
                    </Button>
                    <Button
                        variant="contained"
                        disabled={sending || !email.trim()}
                        onClick={() => onSend(email, message)}
                        data-test="customer-e-invoicing.send-invite"
                    >
                        {translate('client-directory:E_INVOICING_INVITE_SEND')}
                    </Button>
                </>
            }
        >
            <Box display="flex" flexDirection="column" gap={2}>
                <Typography variant="body2">{translate('client-directory:E_INVOICING_INVITE_EXPLANATION')}</Typography>
                <TextField
                    size="small"
                    autoFocus
                    label={translate('client-directory:E_INVOICING_INVITE_EMAIL')}
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                />
                <TextField
                    size="small"
                    multiline
                    minRows={2}
                    label={translate('client-directory:E_INVOICING_INVITE_MESSAGE')}
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                />
            </Box>
        </DHDialog>
    );
};

export default EInvoiceInviteDialog;
